/* eslint-disable no-console */
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

const initiateSentry =
  process.env.REACT_APP_ENVIRONMENT === 'prod' || process.env.REACT_APP_ENVIRONMENT === 'dev';

if (initiateSentry) {
  Sentry.init({
    dsn: 'https://79ef5816b48a485e98e04ef72474ca9b@o486889.ingest.sentry.io/5910288',
    release: process.env.REACT_APP_VERSION,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 0.1,
    environment: process.env.REACT_APP_ENVIRONMENT,
    // https://forum.sentry.io/t/unhandledrejection-non-error-promise-rejection-captured-with-value/14062/16
    ignoreErrors: ['Non-Error promise rejection captured with value:']
  });
}
